module.exports = __webpack_public_path__ + "img/top2.1766306608134.png";